import { type FC } from 'react';
import styles from './NewsCard.module.scss';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { NewsType } from 'Src/Types';

type NewsCardProps = Pick<NewsType, 'title' | 'content' | 'updateDate'>;

export const NewsCard: FC<NewsCardProps> = ({ title, content, updateDate }) => {
	return (
		<Card body color="warning" outline className="m-0 mb-3 me-3">
			<CardHeader className={styles.header} tag={'h5'}>
				{title}
			</CardHeader>

			<CardBody>
				<div
					className={styles.content}
					dangerouslySetInnerHTML={{ __html: content }}
				/>
			</CardBody>

			<CardFooter className="text-body-secondary">
				{updateDate}
			</CardFooter>
		</Card>
	);
};
